<template>
  <nav class="navigation" v-on-click-outside="toggleNavigationOutside">
    <div class="container">
      <div class="navigation-main">
        <div class="navigation-brand">
          <router-link :to="{ path: getHome(data.settings.translatable, data.settings.locality) }">
            <img src="/app/images/logo/logo.svg" :alt="getSnippets('Company')">
            <div class="title">{{ getSnippets('Company') }}</div>
          </router-link>
        </div>
        <div class="navigation-list">
          <ul>
            <li v-for="item in data.navigation.main" :key="item.id">
              <router-link :to="{ path: item.slug }">
                {{ getTranslation(item, 'title') }}
              </router-link>
              <ul class="submenu" v-if="item.content && item.content.allowSubMenu === 'true'">
                <li v-for="subPage in item.subMenu">
                  <router-link :to="{ path: subPage.slug }">
                    {{ getTranslation(subPage, 'title') }}
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
          <div class="navigation-tools">
            <div class="socials">
              <a :href="`${getSnippets('Facebook')}`" target="_blank">
                <i class="fab fa-facebook-f fa-fw"></i>
              </a>
              <a :href="`${getSnippets('Instagram')}`" target="_blank">
                <i class="fab fa-instagram fa-fw"></i>
              </a>
            </div>
            <a href="#" class="navigation-toggle" :class="{ opened: toggle }" @click.prevent="toggleNavigation">
              <span class="hamburger">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="navigation-menu" :class="{ opened: toggle }">
      <a href="#" class="navigation-toggle" :class="{ opened: toggle }" @click.prevent="toggleNavigation">
        {{ getSnippets('Close') }}
        <span class="hamburger">
          <span></span>
          <span></span>
          <span></span>
        </span>
      </a>
      <ul class="navigation-list">
        <li v-for="item in data.navigation.main" :key="item.id">
          <router-link :to="{ path: item.slug }">
            {{ getTranslation(item, 'title') }}
          </router-link>
        </li>
      </ul>
      <ul class="navigation-contact">
        <li>
          <a :href="`tel:${getSnippets('Company Phone')}`" target="_blank">
            T: {{ getSnippets('Company Phone') }}
          </a>
        </li>
        <li>
          <a :href="`mailto:${getSnippets('Company Email')}`" target="_blank">
            E: {{ getSnippets('Company Email') }}
          </a>
        </li>
        <li>
          A: {{ getSnippets('Company Address') }}
        </li>
      </ul>
      <div class="navigation-illustration">
        <img src="/app/images/logo/logo-illustration.png" :alt="getSnippets('Company')">
      </div>
    </div>
  </nav>
</template>

<script>
/* Mixins */
import {Default} from '@mixins/Default';

/* Logic */
export default {
  name: 'Navigation',
  mixins: [Default],
  props: [
    'data'
  ],
  data: function () {
    return {
      toggle: false
    }
  },
  methods: {
    toggleNavigation: function () {
      this.toggle === true ? this.toggle = false : this.toggle = true;
    },
    toggleNavigationOutside: function () {
      this.toggle = false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/App/Partials/Navigation.vue